// normalizeString: remove diacritics and normalize spacing/case
export function normalizeString(s) {
  if (s == null) return s;
  return String(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Chave de comparação: sem acento, espaço normalizado e minúsculo. Usada para
 * casar nomes vindos da API (etapas, drivers, cidades) com os do front.
 */
export function normalizeKey(s) {
  return (normalizeString(s ?? "") || "").toLowerCase();
}

export default normalizeString;
